import { AdminFormSection } from '@ui';
import { MainContactForm } from '@lp/features/admin/forms/MainContactForm';
import { memo } from 'react';
import { Contact } from '@/api/apis/facilities';
import { ContactSelector } from './components/ContactSelector';
import { usePrimaryContactHandlers } from './components/usePrimaryContactHandlers';

export type PrimaryContactFormProps = {
  isReadOnly?: boolean;
  list?: Contact[];
  isDisabled?: boolean;
  isRequired?: boolean;
  isPhoneRequired?: boolean;
  isClearableForm?: boolean;
};

export const NO_PRIMARY_CONTACT_VALUE = '__NO_PRIMARY_CONTACT__';

export const PrimaryContactForm = memo(
  ({
    list,
    isReadOnly = false,
    isDisabled = false,
    isRequired = false,
    isPhoneRequired = false,
    isClearableForm = false,
  }: PrimaryContactFormProps) => {
    const { selectItems, clearPrimaryContact, onContactChange, onImageChange, photoPath, primaryContactName } =
      usePrimaryContactHandlers({ list });

    return (
      <AdminFormSection
        title="Primary Contact Details"
        withAvatar
        imageUrl={photoPath}
        name={primaryContactName}
        isReadOnly={isReadOnly || isDisabled}
        onImageChange={onImageChange}
        startContent={
          list ? (
            <ContactSelector
              selectItems={selectItems}
              isDisabled={isDisabled}
              isRequired={isRequired}
              isClearableForm={isClearableForm}
              onContactChange={onContactChange}
              clearPrimaryContact={clearPrimaryContact}
            />
          ) : null
        }
        type="user"
      >
        <MainContactForm isPhoneRequired={isPhoneRequired} isReadOnly={isReadOnly} isNameRequired={isRequired} />
      </AdminFormSection>
    );
  },
);
